// ROUTE: src/services/rugbyStatsService.js

import axios from "axios";
import API_BASE_URL from "../config/config.js";

async function getRugbyStats(url, { idevent, idsport }) {
  const response = await axios.get(`${API_BASE_URL}${url}`, {
    params: {
      idevent: Number(idevent),
      idsport: Number(idsport),
    },
  });

  return response.data;
}

export async function getRugbyTryScorers({ idevent, idsport }) {
  return getRugbyStats("/estadistica/rugby/tries-legacy", {
    idevent,
    idsport,
  });
}

export async function getRugbyTryScorersByDate({ idevent, idsport }) {
  return getRugbyStats("/estadistica/rugby/tries-by-date", {
    idevent,
    idsport,
  });
}

export async function getRugbyConversionStats({ idevent, idsport }) {
  return getRugbyStats("/estadistica/rugby/conversions", { idevent, idsport });
}

export async function getRugbyPenaltyScorers({ idevent, idsport }) {
  return getRugbyStats("/estadistica/rugby/penalties", { idevent, idsport });
}

/**
 * PURPOSE:
 * Consume the backend-prepared cumulative rugby statistics for /tabla-acumulada.
 *
 * RESPONSIBILITIES:
 * - Request stats using only the current idevent.
 * - Let the backend resolve cumulative_table.ids_events and idsport.
 * - Keep HTTP details outside UI components.
 *
 * COLLABORATORS:
 * - src/components/TablaAcumulada/RugbyCumulativeStats.jsx
 * - controllers/estadistica/RugbyCumulativeStats.js
 */
export async function getRugbyCumulativeStats({ idevent, seriesId }) {
  const response = await axios.get(
    `${API_BASE_URL}/estadistica/rugby/cumulative-stats`,
    {
      params: {
        idevent: Number(idevent),
        ...(seriesId ? { seriesId: Number(seriesId) } : {}),
      },
    }
  );

  return response.data;
}
